import { useMutation } from '@tanstack/react-query';

import { addNotification } from 'notifications';
import { api, type ApiRequestConfig } from 'api/v1/api';
import { getApiErrorMessage, getApiSuccessMessage } from 'utils/getApiErrorMessage';

export type EmailFlowResponse = {
  status?: string;
  message?: string;
  email_sent?: boolean;
  email?: string;
};

export const useResendEmail = () => {
  return useMutation<EmailFlowResponse, Error, string>({
    mutationFn: async (email: string) => {
      const response = await api.post(
        '/users/resend-registration-email/',
        { email },
        { skipAuthRefresh: true, skipGlobalErrorHandler: true },
      );
      return response.data;
    },
    onSuccess: (data) => {
      addNotification(
        getApiSuccessMessage(data, 'Письмо отправлено повторно'),
        data.email_sent ? 'success' : 'info',
      );
    },
    onError: (error) => {
      addNotification(
        getApiErrorMessage(error, 'Не удалось отправить письмо'),
        'error',
      );
    },
  });
};

export const useChangeUnverifiedEmail = () => {
  return useMutation<
    EmailFlowResponse,
    Error,
    { email: string; password: string; new_email: string }
  >({
    mutationFn: async (payload) => {
      const response = await api.post(
        '/users/change-unverified-email/',
        payload,
        { skipAuthRefresh: true, skipGlobalErrorHandler: true },
      );
      return response.data;
    },
    onSuccess: (data) => {
      if (data.email) {
        localStorage.setItem('registration_email', data.email);
      }
      addNotification(
        getApiSuccessMessage(data, 'Адрес изменен, проверьте новое письмо'),
        data.email_sent ? 'success' : 'info',
      );
    },
    onError: (error) => {
      addNotification(
        getApiErrorMessage(error, 'Не удалось сменить email'),
        'error',
      );
    },
  });
};

export const useVerifyEmail = () => {
  return useMutation({
    mutationFn: async (data: { token: string; browser_key?: string | null }) => {
      const response = await api.post('/users/verify-email/', data, {
        skipAuthRefresh: true,
        skipGlobalErrorHandler: true,
        skipAuthHeader: true,
      } as ApiRequestConfig);
      return response.data;
    },
  });
};
